import type { EnvironmentConfig } from '../types';

export type AppSettings = EnvironmentConfig;

let cachedConfig: AppSettings | null = null;

const DEFAULT_CONFIG: AppSettings = {
  authApiDomain: 'http://localhost:5200',
  petseoApiDomain: 'http://localhost:5101',
  environment: 'LOCALHOST',
};

export async function loadConfig(): Promise<AppSettings> {
  if (cachedConfig) return cachedConfig;

  try {
    const response = await fetch('/appsettings.json');
    if (!response.ok) {
      throw new Error(`Failed to load config: ${response.status}`);
    }
    cachedConfig = await response.json();
    return cachedConfig!;
  } catch {
    console.warn('Could not load appsettings.json, using defaults');
    cachedConfig = DEFAULT_CONFIG;
    return cachedConfig;
  }
}

export function getConfig(): AppSettings {
  if (!cachedConfig) {
    throw new Error('Config not loaded. Call loadConfig() first.');
  }
  return cachedConfig;
}
